import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';

export const apiSlice = createApi({
  reducerPath: 'api',
  baseQuery: fetchBaseQuery(),
  tagTypes: [
    'booking',
    'availability',
    'reservation',
    '/reservation/scheduled_trips/find',
    'account',
    'next_departures',
    'daily_timetable',
    'gift_cards',
    'checkout',
    '/service/scheduled_trip_availability',
    'issued_tickets',
  ],
  endpoints: () => ({}),
});
